import { connect } from 'react-redux';
import { RootState } from 'store/types';
import PackRegistration from './PackRegistration';

const mapStateToProps = (state: RootState) => ({
  packSummary: state.packs.packSummary,
});

export default connect(mapStateToProps)(PackRegistration);
